module.exports = __webpack_public_path__ + "static/media/integral-card-dec.90ccb121.png";